import ProxyBase from '../../../../../../core/proxies/ProxyBase'

export class BusinessOperatingStatusProxy extends ProxyBase {
  getBusinessOperatingStatusTable(params) {
    return this.get('BusinessOperatingStatus', params)
  }
  exportBusinessOperatingStatus(params) {
    return this.post('BusinessOperatingStatus/Export', params, {}, 'download')
  }
}

export default new BusinessOperatingStatusProxy('IndustryOverview/')
